import React from "react";
import "./WhyChooseUs.css";

import {
  BrainCircuit,
  ShieldCheck,
  LayoutDashboard,
  Rocket,
  CloudCog,
  Code2,
  Database,
  Workflow,
} from "lucide-react";

const features = [

  {
    icon: <BrainCircuit size={34} />,
    title: "AI-First Development",

    description:
      "We build intelligent software systems powered by AI automation, OCR workflows, analytics and scalable business logic.",
  },

  {
    icon: <Code2 size={34} />,
    title: "Modern Tech Stack",

    description:
      "Enterprise applications developed using React, FastAPI, PostgreSQL, Node.js and scalable cloud-ready architecture.",
  },

  {
    icon: <LayoutDashboard size={34} />,
    title: "Enterprise Dashboards",

    description:
      "Advanced dashboards with realtime analytics, reporting systems, workflow automation and operational visibility.",
  },

  {
    icon: <CloudCog size={34} />,
    title: "Cloud Ready Deployment",

    description:
      "Production-grade deployment pipelines with Docker, VPS infrastructure, scalable hosting and cloud integrations.",
  },

  {
    icon: <Workflow size={34} />,
    title: "Business Automation",

    description:
      "Automate workflows, approvals, monitoring systems and operational processes with custom enterprise software.",
  },

  {
    icon: <Database size={34} />,
    title: "Scalable Architecture",

    description:
      "Structured backend systems designed for performance, scalability, data integrity and future business growth.",
  },

  {
    icon: <ShieldCheck size={34} />,
    title: "Secure Systems",

    description:
      "Secure authentication, protected APIs, database integrity and enterprise-grade backend implementation practices.",
  },

  {
    icon: <Rocket size={34} />,
    title: "Long-Term Support",

    description:
      "Continuous optimization, deployment support, maintenance workflows and scalable product enhancement strategies.",
  },

];

const WhyChooseUs = () => {

  return (

    <section className="why-section">

      <div className="why-container">

        {/* HEADER */}
        <div className="why-header">

          <p className="why-label">
            WHY CHOOSE US
          </p>

          <h2 className="why-title">

            Why Businesses Choose
            <br />

            Bairagi Consultants

          </h2>

          <p className="why-description">

            We combine scalable architecture,
            modern UI/UX, AI-powered systems and
            enterprise-grade development practices
            to build high-performance software
            solutions for modern businesses.

          </p>

        </div>

        {/* GRID */}
        <div className="why-grid">

          {features.map((item, index) => (

            <div
              className="why-card"
              key={index}
            >

              <div className="why-icon">

                {item.icon}

              </div>

              <h3>
                {item.title}
              </h3>

              <p>
                {item.description}
              </p>

            </div>

          ))}

        </div>

      </div>

    </section>

  );

};

export default WhyChooseUs;